import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PageTitle } from "./DashboardLayout";

export default function AuditLogs() {
  const { data: logs } = useQuery({ queryKey: ["audit"], queryFn: () => api.get("/audit-logs").then(r => r.data.logs) });
  return (
    <div>
      <PageTitle title="Audit Logs" subtitle="Sensitive operations are recorded here" />
      <div className="rounded-xl bg-white border border-slate-200 overflow-x-auto">
        <table className="w-full text-sm"><thead className="bg-slate-50 text-slate-500 text-xs uppercase font-mono"><tr><th className="text-left p-3">Time</th><th className="text-left p-3">Action</th><th className="text-left p-3">Entity</th><th className="text-left p-3">User</th></tr></thead>
          <tbody>
            {(logs || []).length === 0 ? <tr><td colSpan={4} className="p-8 text-center text-slate-400">No audit entries yet.</td></tr> :
              (logs || []).map((l, i) => (
                <tr key={i} className="border-t border-slate-100" data-testid={`audit-row-${i}`}>
                  <td className="p-3 text-slate-500 font-mono text-xs">{new Date(l.createdAt).toLocaleString()}</td>
                  <td className="p-3"><span className="text-xs px-2 py-0.5 rounded bg-electric/10 text-electric">{l.action}</span></td>
                  <td className="p-3 text-slate-600">{l.entity}{l.entityId && <span className="text-xs text-slate-400 font-mono"> · {String(l.entityId).slice(0, 8)}</span>}</td>
                  <td className="p-3 text-slate-600">{l.userEmail || "system"}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
